import { styled } from '@mui/material/styles';
import TwBaseCard from '../TwCard/TwCard';
import CardContent from '@mui/material/CardContent';
import { ReactComponent as InfoIcn } from '../../assets/info.svg';

export const InfoIcon = styled(InfoIcn)(({ theme }) => ({
  height: '20px',
  width: '20px'
}));

export const InfoCard = styled(TwBaseCard)(({ theme }) => ({
  '& .MuiCardContent-root:last-child': {
    paddingBottom: '16px'
  },

  [theme.breakpoints.down('sm')]: {
    '& .tid-info-card__title': {
      fontSize: '12px'
    },

    '& .tid-info-card__info': {
      fontSize: '21px'
    },

    '& .tid-info-card__subinfo': {
      fontSize: '12px'
    }
  }
}));

export const InfoCardContent = styled(CardContent)(({ theme }) => ({}));

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between'
}));

export const IconSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
}));
